import {
  IRedistributionGenericRule,
  IRedistributionGenericRuleForm,
  IRedistributionGenericRulePayload,
} from '~/connect/types';

// The form and the API share the status vocabulary, so both directions are a pass-through. The
// widget never produces INTERMEDIATE; only the API does, and only for supplier templates.
export const rawToForm = (
  genericRule: IRedistributionGenericRule,
): IRedistributionGenericRuleForm => ({
  businessRules: genericRule.businessRules,
});

export const formToPayload = (
  form: IRedistributionGenericRuleForm,
): IRedistributionGenericRulePayload => ({
  businessRules: form.businessRules,
});
